export default __webpack_public_path__ + "static/rsz_coming_soon-386020cf105ffd0cfb8ccf97255034f5.png";